import React,{ useState, useEffect } from 'react';
import { Badge } from 'primereact/badge';
import axios from 'axios';
import { CHECK_EXISTING_USER } from '../constant'; 
import { debounce } from 'lodash';
        

//const {errors} = formState;
function ConfirmPassword({register,getValues,errors,isEditMode}) {
    
    let [userNameAvailable, setUserNameAvailable] = useState(null);
    let [userNameError, setUserNameError] = useState(null);
  
    const handleKeyUp = debounce(async (e) => {
        console.log(e.target.value ,"***",e.target);
        
      if (e.target.value) {
        try {
            //const username =  e.target.value;
            //console.log(data.length)
          const response = await axios.post(CHECK_EXISTING_USER,{
            username: e.target.value,
          } );
          const data = response.data;
          console.log("check length ::", typeof data.length);
          //alert(data.length );
          if (data.length > 0) {
            console.log('hhhhhh');
            setUserNameAvailable(false);
            setUserNameError('Username already exists');
            register('u_nme', {
              validate: (value) => 'Username already exists',
            });
          } else {
            // Username is available - clear error states
            setUserNameAvailable(true);
            setUserNameError(null);
            // Remove the validation error
            register('u_nme', {
              validate: (value) => true,
            });
          }
        } catch (error) {
          console.error(error);
        }
      }
      else if(e.target.value.trim() === ''){
        setUserNameAvailable(null);
        setUserNameError(null);
      }
    },500);// delay the API call by 500ms
    const validateConfirmPassword = (value) => {
        if (value !== getValues('u_pswd')) {
          return 'Passwords do not match';
        }
      };
      const passwordRequired = isEditMode ? false : { value: true, message: 'Password is required' };
      const requiredClass = isEditMode ? '' : 'require-field';
      
  return (
    <div className='user-details'>
        <div>
            <label  className='require-field'>User Name</label>
            <input type="text" 
            className="form-control"
            autoComplete='off'  
           id="u_nme" 
          {...register('u_nme',{required:{
              value: true,
              message: 'User Name is required'
         }})} 
         onBlur={(e) => {
          if (e.target.value === '') {
            // Clear the error message
            setUserNameError(null);
          }
        }}
         onKeyUp={handleKeyUp} 
         onKeyDown={(e) => {
          if (e.key === ' ') {
            e.preventDefault();
          }
        }}
         />
                                
         {userNameError ? ( <p className="errors">{userNameError}</p>) 
         : (errors && errors.u_nme?.message && ( <p className='errors'>{errors.u_nme.message}</p>)
  )}
        </div>
        <div>
            <label  className={requiredClass}>Password</label>
            <input type="password" 
            className="form-control" 
            autoComplete='new-password'   
            id="u_pswd" 
            {...register('u_pswd',{required:passwordRequired})}  />
            <p className='errors'>{errors && errors.u_pswd?.message}</p>
        </div>                  
         <div>
                <label  className={requiredClass}>Confirm Password</label>
                <input type="password" 
                className="form-control" 
                autoComplete='off'   
                id="c_pswd" 
                {...register('c_pswd',{required:passwordRequired,
                 validate: validateConfirmPassword})}  />
                <p className='errors'>{errors && errors.c_pswd?.message}</p>
        </div>
    </div>
  )
}

export default ConfirmPassword